import * as React from "react";

export interface IFooterTextProps {
    logoUrl?: string;
    logoSrc?: string;
    logoAlt?: string;
    logoTitle?: string;
    richText?: string;
}

const FooterText: React.SFC<IFooterTextProps> = ({ logoUrl, logoSrc, logoAlt, logoTitle, richText }) => (
    <div className="footer-text">
        <a href={logoUrl}>
            <img src={logoSrc} alt={logoAlt} title={logoTitle} />
        </a>
        {richText && (
            <div
                className="footer-text__rich-text content-rich-text"
                dangerouslySetInnerHTML={{ __html: richText }}
            />
        )}
    </div>
);

export default FooterText;
